export default {
  namespaced: true,
  state: {
    forcedEmail: null,
    email: null,
    password: null,
  },
  mutations: {
    FORCE_EMAIL(state, { email }) {
      state.forcedEmail = email;
    },
    SET_CREDENTIALS(state, { email, password }) {
      state.email = email;
      state.password = password;
    },
  },
  actions: {
    forceEmail({ commit }, { email }) {
      commit('FORCE_EMAIL', { email });
    },
    setCredentials({ commit }, { email, password }) {
      commit('SET_CREDENTIALS', { email, password });
    },
  },
  getters: {
    getCredentials(state) {
      return { email: state.email, password: state.password };
    },
    hasCredentials(state) {
      return !!(state.email && state.password);
    },
  },
};
